module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('strong', [_vm._v("Introducing this exciting rerelease of "), _c('em', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Lynne Graham’s longer-length Harlequin Presents title, "), _c('em', [_vm._v("Emerald Mistress")]), _vm._v(", available digitally for the first time!")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_vm._v("When Harriet Carmichael’s world comes crashing down, she’s determined to count her blessings. Forget London, her failing career and her unfaithful fiancé—an unexpected legacy of a cottage and stables in an Irish village beckons!")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_vm._v("But her fresh start is soon threatened by Rafael Cavaliere: her new neighbour "), _c('em', [_vm._v("and")]), _vm._v(" the very man who cost Harriet her job! With her heart so recently burned she’s reluctant to become another notch on his bedpost, but when passion ensnares them both, deep secrets are revealed—ones that could change their lives forever.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f1787c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/bcc.vue
// module id = 57
// module chunks = 0